import { HostedGamesService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MarkGamePlayerAsNotPaidPathParams, MarkGamePlayerAsPaidPathParams } from '@core-http';

export class MarkAsPaidCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);

  markAsPaid(gameId: string, playerId: string, isPaid: boolean): Observable<void> {
    if (!isPaid) {
      const pathParams: MarkGamePlayerAsPaidPathParams = { hostedGameId: gameId, gamePlayerId: playerId };
      return this.hostedGamesService.markAsPaid(pathParams);
    }

    const pathParams: MarkGamePlayerAsNotPaidPathParams = { hostedGameId: gameId, gamePlayerId: playerId };
    return this.hostedGamesService.markAsNotPaid(pathParams);
  }
}
